export default __webpack_public_path__ + "static/fv-nr-4-669bcf4ef99535113c93aec3970a5147.avif";